import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
const __URL_API__ = `${environment.URL_API}`;

@Injectable({ providedIn: 'root' })
export class MaintainService {
  private _http = inject(HttpClient);

  getMaintainInfos(): Observable<string> {
    return this._http
      .get<string>(__URL_API__ + 'api/Maintain/GetMaintainInformations')
      .pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: any): Observable<never> {
    return throwError(() => error.message || error);
  }
}
